var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('img',{staticClass:"w-70 m-auto object-cover",attrs:{"src":require("@/assets/images/MicrosoftTeams-image (6).png")}})])
}]

export { render, staticRenderFns }